import {
    AbstractAuthenticationAppRouterService
} from "@shopliftr/common-ng";
import { AdminRoutingId } from "../enums/admin-routing-id";
import { Injectable } from "@angular/core";

/**
 * The RouterService for the Admin application
 *
 * A RouterService should be created for each RoutingModule.
 * It is the way that Components, Directives and Services will interact with the router
 *
 * @see AbstractRouterService
 * @see AdminRoutingModule
 * @see AdminRoutingId
 */
@Injectable()
export class AppRouterService extends AbstractAuthenticationAppRouterService<AdminRoutingId> {

    get isDashboard(): boolean {
        return this.isRouteActive(AdminRoutingId.Dashboard);
    }

    get isGettingStarted(): boolean {
        return this.isRouteActive(AdminRoutingId.GettingStarted);
    }

    get isKeywordManagement(): boolean {
        return this.isRouteActive(AdminRoutingId.KeywordManagement);
    }

    get isProduct(): boolean {
        return this.isRouteActive(AdminRoutingId.Product);
    }

    get isTasks(): boolean {
        return this.isRouteActive(AdminRoutingId.Tasks);
    }

    get isUsers(): boolean {
        return this.isRouteActive(AdminRoutingId.Users);
    }

    get isDealSearch(): boolean {
        return this.isRouteActive(AdminRoutingId.DealSearch);
    }

    get isStoreManagement(): boolean {
        return this.isRouteActive(AdminRoutingId.StoreManagement);
    }

    /**
     * Navigate to the dashboard
     */
    toDashboard(): void {

        this._navigateByRouteId(AdminRoutingId.Dashboard);
    }

    toGettingStarted(): void {

        this._navigateByRouteId(AdminRoutingId.GettingStarted);
    }

    toKeywordManagement(): void {

        this._navigateByRouteId(AdminRoutingId.KeywordManagement);
    }

    toProduct(): void {

        this._navigateByRouteId(AdminRoutingId.Product);
    }

    toTasks(): void {

        this._navigateByRouteId(AdminRoutingId.Tasks);
    }

    toUsers(): void {

        this._navigateByRouteId(AdminRoutingId.Users);
    }

    toDealSearch(): void {

        this._navigateByRouteId(AdminRoutingId.DealSearch);
    }

    toStoreManagement(): void {

        this._navigateByRouteId(AdminRoutingId.StoreManagement);
    }

}
